import { CircularProgress, Page, PageFace } from 'ui/components'

import { Footer, Form } from './components'
import { useCreate } from './useCreate'

const Create = () => {
  const { cancelManage, data, formApi, isFetching, isPending, isSuccess, SaveConfirmation, submitForm } = useCreate()

  if (isFetching && !data) {
    return <CircularProgress centered />
  }

  if (!data) {
    return null
  }

  const { companyName, licenseOptions } = data

  return (
    <Page
      face={PageFace.SECONDARY}
      subTitle="New Bank Account"
      isPending={isFetching}
      footer={
        <formApi.Subscribe
          children={({ isSubmitting }) => (
            <Footer onCancel={cancelManage} onSubmit={submitForm} loading={isSubmitting || isPending} />
          )}
        />
      }
    >
      <SaveConfirmation />
      <Form
        licenses={licenseOptions}
        companyName={companyName}
        isSubmitting={isPending}
        isSuccess={isSuccess}
        formApi={formApi}
      />
    </Page>
  )
}

export default Create
